import React from 'react'
import { twMerge } from 'tailwind-merge'

import { quote } from '@ui-kit/components/Quote/styles'

const Quote = (props: { children: React.ReactNode }) => {
  const { wrapper, text } = quote()
  return <p className={twMerge(wrapper(), text())}>{props.children}</p>
}

export default Quote
